const config = [
  { propName: 'kanbanInitialList', reducerName: 'kanbanInitialList' },
  { propName: 'rejectedCount', reducerName: 'rejectedCount' },
  { propName: 'sort', reducerName: 'sort' },
  { propName: 'kanbanData', reducerName: 'kanbanData' },
  { propName: 'appReviewSort', reducerName: 'appReviewSort' },
  { propName: 'kanbanListVersion', reducerName: 'kanbanListVersion' },
  {
    propName: 'needsCustomSortAndAppReviewHasApplications',
    reducerName: 'needsCustomSortAndAppReviewHasApplications',
  },
];

export const getPipelineDetails = (state) => {
  const pipeline = {};

  config.forEach(({ propName, reducerName }) => {
    pipeline[propName] = state?.pipelineData?.[reducerName];
  });

  return pipeline;
};
